exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/** Google charts styling  */\r\n  .bold-green-font {\r\n     font-weight: bold;\r\n     color: green;\r\n }\r\n\r\n.bold-font {\r\n    font-weight: bold;\r\n}\r\n\r\n.right-text {\r\n    text-align: right;\r\n}\r\n\r\n.darkblue-font {\r\n    color: darkblue;\r\n}\r\n\r\n.italic-purple-font {\r\n    font-style: italic;\r\n    color: purple;\r\n}\r\n\r\n.underline-blue-font {\r\n    text-decoration: underline;\r\n    color: blue;\r\n}\r\n\r\n.gold-border {\r\n    border: 3px solid gold;\r\n}\r\n\r\n.deeppink-border {\r\n    border: 3px solid deeppink;\r\n}\r\n\r\n.orange-background {\r\n    background-color: orange;\r\n}\r\n\r\n.orchid-background {\r\n    background-color: orchid;\r\n}\r\n\r\n.beige-background {\r\n    background-color: beige;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./ClientApp/css/googlecharts-customizations.css
// module id = 114
// module chunks = 0